import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ImageLoadDirective } from '@directives/image-load.directive';
import { ArucoSticker } from '@modules/aruco/models/aruco-sticker';
import { ImageLoadingComponent } from '@modules/shared/image-loading/image-loading.component';
import { ErrorIconComponent } from '@shared/components/error-icon/error-icon.component';
import { ActionStatus } from '@pixacare/shared';
import { ArucoDetectorDirective } from '../../directives/aruco-detector.directive';

@Component({
  selector: 'pxc-picture-aruco',
  imports: [
    CommonModule,
    ArucoDetectorDirective,
    ImageLoadingComponent,
    ErrorIconComponent,
    TranslocoDirective,
    ImageLoadDirective,
  ],
  templateUrl: './picture-aruco.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'relative block size-full',
  },
})
export class PictureArucoComponent {
  readonly source = input<string>();

  readonly arucoDetectedChange = output<boolean>();
  readonly arucoSurfaceChange = output<number>();

  protected readonly ActionStatus = ActionStatus;
  protected readonly state = signal<ActionStatus>(ActionStatus.IN_PROGRESS);

  protected onPictureLoad(): void {
    this.state.set(ActionStatus.SUCCESS);
  }

  protected onPictureError(): void {
    this.state.set(ActionStatus.ERROR);
  }

  protected emitArucoSticker({ hasMarkers, surface }: ArucoSticker): void {
    this.arucoDetectedChange.emit(hasMarkers);
    this.arucoSurfaceChange.emit(surface);
  }
}
